import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Carousel, Col, Modal, Row } from 'antd';
import { Page } from 'lemans-brandsites-common/components/Page';
import { Spinner } from 'lemans-brandsites-common/components/Spinner';
import { IEntityMedia, IFeedProduct, IFeedProductGroup } from 'lemans-brandsites-common/libs/ProductFeed/masterFeed.types';
import { useProductGroup } from 'lemans-brandsites-common/libs/ProductFeed/useProductFeed';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Slide } from 'react-slideshow-image';
import { brandName } from 'theme/libs/config';
import { categoryUrl } from 'theme/libs/routes';
import { imageUrl } from 'theme/libs/util';
import { first } from 'ts-functional';
import { OnlineDealers } from '../OnlineDealers';
import { ProductAccessories } from '../ProductAccessories';
import { ProductBullets } from '../ProductBullets';
import { ProductOptions } from '../ProductOptions';
import { ProductPrice } from '../ProductPrice';
import { ProductRelatedProducts } from '../ProductRelatedProducts';
import { ProductSecondaryImages } from '../ProductSecondaryImages';
import { ProductSizing } from '../ProductSizing';
import { ProductTitle } from '../ProductTitle';
import './Product.styles.less';
import { IProductProps } from "./Product.types";

export const Product = (props: IProductProps) => {
    const [data, loading] = useProductGroup(+props.productGroupId);
    const [isOnlineDealersVisible, setIsOnlineDealersVisible] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [showSecondaryModal, setShowSecondaryModal] = React.useState(false);
    const [selectedMediaId, setSelectedMediaId] = React.useState(0);

    React.useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const product:IFeedProduct | undefined = !!data?.products ? data.products[0] : undefined;
    const productGroup:IFeedProductGroup | undefined = !!product && !!product.productGroups
        ? first(product.productGroups.filter(g => g.productGroupId === +props.productGroupId))
        : undefined;

    const relatedProducts  = !!productGroup && productGroup.relatedEntity ? productGroup.relatedEntity.filter(pg => pg.tag.toLowerCase().indexOf("accessories"     ) === -1            ) : [];
    const accessories      = !!productGroup && productGroup.relatedEntity ? productGroup.relatedEntity.filter(pg => pg.tag.toLowerCase().indexOf("accessories"     ) >= 0) : [];
    const accessoryImages   = !!productGroup && productGroup.media ? productGroup.media.filter(media => media.tag.toLowerCase() === "accessories"                          ) : [];
    const accessoryMetadata    = !!product && product.metadata ? product.metadata.filter(meta => meta.title.toLowerCase().indexOf("accessory") >= 0) : [];
    const sizeChartLink    = !!product && product.metadata ? product.metadata.filter(meta => meta.title.toLowerCase().indexOf("size_chart_link") >= 0) : [];
    const careInstructionsLink    = !!product && product.metadata ? product.metadata.filter(meta => meta.title.toLowerCase().indexOf("care_instructions_link") >= 0) : [];
    const armorLink    = !!product && product.metadata ? product.metadata.filter(meta => meta.title.toLowerCase().indexOf("armor_link") >= 0) : [];
    const replacementPartsLink    = !!product && product.metadata ? product.metadata.filter(meta => meta.title.toLowerCase().indexOf("replacement_parts") >= 0) : [];

    let allMedia: IEntityMedia[] = [];
    if (productGroup && Array.isArray(productGroup.media)) {
      allMedia = productGroup.media.slice();
    }

    const getVideoId = (vid?:IEntityMedia) => !!vid ? vid.mediaUrl.replace("youtube-", "") : "";

    const showOnlineDealers = () => setIsOnlineDealersVisible(true);
    const onWebDelearModalClose = () => setIsOnlineDealersVisible(false);

    const carouselRef = React.useRef<any>(null);
    // const [carouselIndex, setCarouselIndex] = React.useState(0);
    const productImages = allMedia.filter((media: IEntityMedia) => 
      media.mediaTypeDescription === 'image' && 
      media.entityClass?.toLowerCase() === 'productgroup' && 
      media.tag?.toLowerCase() !== 'secondary' &&
      media.tag?.toLowerCase() !== 'accessories'
    );

    const secondaryImages = allMedia.filter((media: IEntityMedia) => typeof media.tag === 'string' && media.tag.toLowerCase() === 'secondary');


    const getImageUrl = (
      media: IEntityMedia,
      size: { x: number; y: number; t?: "image/png" | "image/png" } = { x: 800, y: 800, t: "image/png" }
    ) => imageUrl(media, size);

    // const handleThumbnailClick = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    //   const idx = Number(e.currentTarget.getAttribute('data-idx'));
    //   setCarouselIndex(idx);
    //   if (carouselRef.current) {
    //     carouselRef.current.goTo(idx);
    //   }
    // }, [setCarouselIndex, carouselRef]);

    // const handleCarouselBeforeChange = React.useCallback((_: number, next: number) => {
    //   console.log(next)
    //   setCarouselIndex(next);
    // }, []);

    const zoom = (e:any) => {
        const zoomer = e.currentTarget;
        const offsetX = e.nativeEvent.offsetX ? e.nativeEvent.offsetX : e.touches[0].pageX;
        const offsetY = e.nativeEvent.offsetY ? e.nativeEvent.offsetY : e.touches[0].pageY;
        const x = offsetX/zoomer.offsetWidth*100
        const y = offsetY/zoomer.offsetHeight*100
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
    }

    // const carouselSlides = React.useMemo(() =>
    //   productImages.length > 0
    //     ? productImages.map((media, idx) => (
    //         <div key={media.mediaId || idx} className="carousel-image-wrapper" style={{
    //           alignItems: 'center',  
    //           display: 'flex',
    //           height: '400px', // Fixed height for the wrapper
    //           justifyContent: 'center',
    //           width: '100%'
    //         }}>
    //           <figure
    //               className="zoom"
    //               onMouseMove={zoom}
    //               style={{backgroundImage: `url(${getImageUrl(media, { y: 1300, x:1100, t: 'image/png' })})` }}
    //           >
    //           <Image
    //             src={getImageUrl(media, { x: 800, y: 800, t: "image/png" })}
    //             alt={media.mediaDescription || 'Product Image'}
    //             style={{
    //               background: '#f0f2f3',
    //               borderRadius: 8,
    //               maxHeight: '100%',
    //               maxWidth: '100%',
    //               objectFit: 'contain',
    //               width: 'auto',
    //             }}
    //             // preview={{
    //             //   className: 'product-image-preview',
    //             //   mask: <div style={{ fontSize: '16px' }}>Zoom</div>,
    //             //   maskClassName: 'preview-mask',
    //             //   src: getImageUrl(media, { x: 1200, y: 1200, t: "image/png" }), 
    //             // }}
    //             fallback="/img/placeholder_image.png"
    //             wrapperStyle={{
    //               alignItems: 'center',
    //               background: '#f0f2f3',
    //               display: 'flex',
    //               height: '100%',
    //               justifyContent: 'center',
    //               width: '100%'
    //             }}
    //           />
    //           </figure>
    //         </div>
    //       ))
    //     : 
    //     [
    //         <div key="placeholder" className="carousel-image-wrapper" style={{
    //             alignItems: 'center',
    //             display: 'flex',
    //             height: '400px', // Fixed height for the wrapper
    //             justifyContent: 'center',
    //             width: '100%'
    //           }}>
    //           <div style={{
    //             alignItems: 'center',
    //             background: '#f0f2f3',
    //             borderRadius: 8,
    //             display: 'flex',
    //             height: '100%',
    //             justifyContent: 'center',
    //             width: '100%'
    //           }}>
    //             <span style={{ color: '#bbb', fontSize: 24 }}>No Product Images Available</span>
    //           </div>
    //         </div>
    //       ]
    // , [productImages]);

    const openModal = (mediaId:number) => () => {
        setSelectedMediaId(mediaId)
        setShowModal(true);
    }
    const openSecondaryModal = (mediaId:number) => () => {
        setSelectedMediaId(mediaId)
        setShowSecondaryModal(true);
    }

    // move primary image to the first position 
    if(productImages.length > 0) {
        productImages.unshift(productImages.splice(productImages.findIndex(item => item.mediaUrl === productGroup?.mediaUrl), 1)[0])
    }

    const carouselSlides = 
    !!productImages && productImages.length > 0
      ? productImages.map((media, idx) => (
          <div key={media.mediaId || idx} className="media-item fullframe" style={{
            alignItems: 'center',  
            display: 'flex',
            height: '400px', 
            justifyContent: 'center',
            width: '100%'
          }}>
            <figure
                className="zoom"
                onMouseMove={zoom}
                style={{backgroundImage: `url(${getImageUrl(media, { y: 1300, x:1100, t: 'image/png' })})` }}
            >
              <img
                  className="fullFrame"
                  src={getImageUrl(media, { x: 800, y: 800, t: "image/png" })}
                  onClick={openModal(media.mediaId)}
              />
            </figure>
          </div>
        ))
      : 
        <div className="media-item fullframe" style={{
          alignItems: 'center',  
          display: 'flex',
          height: '400px', 
          justifyContent: 'center',
          width: '100%'
        }}>
          <></>
        </div>;
    
    // mobile images without zoom
    const carouselSlidesMobile = 
    !!productImages && productImages.length > 0
      ? productImages.map((media, idx) => (
          <div key={media.mediaId || idx} className="media-item fullframe" style={{
            alignItems: 'center',  
            display: 'flex',
            height: '400px', 
            justifyContent: 'center',
            width: '100%'
          }}>
            <img
                className="fullFrame"
                src={getImageUrl(media, { x: 800, y: 800, t: "image/png" })}
                onClick={openModal(media.mediaId)}
            />
          </div>
        ))
      : 
        <div className="media-item fullframe" style={{
          alignItems: 'center',  
          display: 'flex',
          height: '400px', 
          justifyContent: 'center',
          width: '100%'
        }}>
          <></>
        </div>;
    
    const closeModal = () => setShowModal(false);
    const closeSecondaryModal = () => setShowSecondaryModal(false);
    const selectedIndex = productImages && productImages.findIndex((element) => element?.mediaId === selectedMediaId);
    const selectedSecondaryIndex = secondaryImages && secondaryImages.findIndex((element) => element?.mediaId === selectedMediaId);

    return <Page
        className="Product"
        title={`${brandName} - Product`}>
        {loading && <Spinner defaultIndicator={true} size="large" />}
        {!loading && !!product && !!productGroup && 
        <>
        {!!allMedia && allMedia.filter((media:IEntityMedia) => media.mediaTypeDescription === "video" && media.tag.toLowerCase() !== 'threesixty' && media.tag.toLowerCase() === 'bannervideo').map((vid, i) => {
            const videoId = getVideoId(vid);
            return (
                <>
                <div className='videoContainer bannervideo'>
                    <iframe
                        allowFullScreen
                        key={`bannervideo-${i}`}
                        className="video"
                        frameBorder={0}
                        src={`https://www.youtube-nocookie.com/embed/${videoId}?wmode=transparent&html5=1&autoplay=1&rel=0&mute=1&controls=0&playlist=${videoId}&loop=1`}
                        style={{width: "100%"}}
                    />
                </div>
                </>
            )
        })}
        <div className="products">
            <Modal className={"onlineDealerModal"} centered destroyOnClose width={'100%'} footer={false} visible={isOnlineDealersVisible} onCancel={onWebDelearModalClose}>
                <OnlineDealers />
            </Modal>
            <div className="product section">
                <Row gutter={[24, 16]} className="section product-main-row">
                    {!!productImages && productImages.length > 0 && productImages[0] !== undefined ? <>
                    <Modal destroyOnClose centered visible={showModal} onCancel={closeModal} footer={false} width={'1400px'} className='prodImgSliderModal'>
                      <Slide autoplay={false} defaultIndex={selectedIndex} prevArrow= {<LeftOutlined style={{fontSize: '30px', marginLeft: '-20px'}}/>} 
                          nextArrow={<RightOutlined  style={{fontSize: '30px', marginRight: '-20px'}}/>} >
                              {productImages.map((image, index) => (
                                  <div key={index} className="eachSlider">
                                      {image.mediaTypeDescription !== 'video' &&
                                          <img
                                              className="fullFrame"
                                              src={imageUrl(image, { y: 1300, x:1100, t: 'image/png' })}
                                              alt={image.mediaDescription}
                                              style={{maxWidth: '100%'}}
                                          />
                                      }
                                  </div>
                              ))}
                      </Slide>
                    </Modal>
                    <Col md={12} xs={0} className="product-image-section desktop" style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        minHeight: '500px'
                    }}>
                        <div className="product-carousel-bg" style={{
                            width: '100%'
                        }}>
                            <Carousel
                                ref={carouselRef}
                                dots
                                arrows
                                className="product-carousel"
                                // beforeChange={handleCarouselBeforeChange}
                                // initialSlide={carouselIndex}
                                prevArrow={<button className="custom-arrow prev"><LeftOutlined /></button>}
                                nextArrow={<button className="custom-arrow next"><RightOutlined /></button>}
                            >
                                {carouselSlides}
                            </Carousel>
                        </div>
                    </Col>
                    <Col md={0} xs={24} className="product-image-section mobile">
                        <div className="product-carousel-bg" style={{
                            width: '100%'
                        }}>
                            <Carousel
                                ref={carouselRef}
                                dots
                                arrows
                                className="product-carousel"
                                prevArrow={<button className="custom-arrow prev"><LeftOutlined /></button>}
                                nextArrow={<button className="custom-arrow next"><RightOutlined /></button>}
                            >
                                {carouselSlidesMobile}
                            </Carousel>
                        </div>
                    </Col>                    
                    </>: <></>
                    } 
                    <Col md={12} xs={24} className="product-info-section">
                        <div className="breadcrumbs">
                            {!!productGroup && product && Array.isArray(product.breadcrumb) && product.breadcrumb.map(crumb =>
                                <span key={crumb.categoryId} className="breadcrumb">
                                    {![15316].includes(crumb.categoryId)
                                        ? <Link to={categoryUrl(crumb.categoryId)}>{crumb.categoryName}</Link>
                                        : <span className="link-styled-text">{crumb.categoryName}</span>
                                    }
                                </span>
                            )}
                        </div>
                        <ProductTitle title={productGroup.productGroupName?.replace(/-/g, ' - ')} caption={productGroup.caption} />
                        <ProductPrice priceRange={productGroup.retailPriceDisplayRange} />
                        <ProductBullets
                            bullets={productGroup.features ? productGroup.features.filter(feature => feature.featureType === 'bullet') : []}
                        />
                        <br />
                        <div className='shopButtons'>
                            <Button><a href={productGroup && productGroup.googleShoppingUrl} target="_blank">Shop Online</a></Button> &nbsp;
                            <Button><a href="/dealer-search">Shop Local</a></Button> &nbsp; 
                            <Button onClick={showOnlineDealers}><div>Online Dealers</div></Button>
                        </div>

                        { !!productGroup.chart && productGroup.chart[0] && productGroup.chart[0].header[0] && productGroup.chart[0].header[0].columns &&
                            <div style={{ margin: '20px 0' }}>
                                <ProductSizing chart={productGroup.chart[0]} />
                            </div>
                        }
                        
                        {/* Colorways section */}
                        <div className="product-colorways-row" style={{ margin: '32px 0' }}>
                            {product.productGroups && product.productGroups.length > 1 &&
                                <ProductOptions
                                    alignItems={"left"}
                                    productGroups={product.productGroups}
                                    title={""}
                                />
                            }
                        </div>
                    </Col>
                </Row>
                <br /> 
                {/* Secondary Images Section */}
                <Row className='section'>
                    <Col span={24}>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Row>
                                    {typeof secondaryImages !== 'undefined' && secondaryImages.length > 0 &&
                                        <div className="section secondaryImages">
                                            <Modal destroyOnClose centered visible={showSecondaryModal} onCancel={closeSecondaryModal} footer={false} width={'1400px'} className='prodImgSliderModal'>
                                                <Slide autoplay={false} defaultIndex={selectedSecondaryIndex} prevArrow= {<LeftOutlined style={{fontSize: '30px', marginLeft: '-20px'}}/>} 
                                                    nextArrow={<RightOutlined  style={{fontSize: '30px', marginRight: '-20px'}}/>} >
                                                        {secondaryImages.map((image, index) => (
                                                            <div key={index} className="eachSlider">
                                                                {image.mediaTypeDescription !== 'video' &&
                                                                    <img
                                                                        className="fullFrame"
                                                                        src={imageUrl(image, { y: 1000, t: 'image/png' })}
                                                                        alt={image.mediaDescription}
                                                                        style={{maxWidth: '100%', objectFit: 'cover', padding: '15px 10px'}}
                                                                    />
                                                                }
                                                            </div>
                                                        ))}
                                                </Slide>
                                            </Modal>
                                            {/* <ProductSecondaryImages secondaryImages={secondaryImages} zoom={zoom} openSecondaryModal={openSecondaryModal}/> */}
                                            <ProductSecondaryImages secondaryImages={secondaryImages} hasZoom={false} openSecondaryModal={openSecondaryModal}/>
                                        </div>
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <br />
                <Row className='section'>
                    <Col span={24}>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                {
                                  typeof accessoryImages !== 'undefined' && accessoryImages.length > 0 &&
                                    <div className="section prodAccessories">
                                        <ProductAccessories accessoryImages={accessoryImages} accessoryMetadata={accessoryMetadata} />
                                    </div>
                                }
                                {(sizeChartLink && sizeChartLink.length !== 0) || (careInstructionsLink && careInstructionsLink.length !== 0) || (armorLink && armorLink.length !== 0) || (replacementPartsLink && replacementPartsLink.length !== 0) ?
                                  <>
                                  <br />
                                  <Row gutter={32} style={{textAlign: 'center', justifyContent: 'center'}}>
                                    {(!!sizeChartLink && sizeChartLink.length !== 0) &&
                                      <Col>{<Button className='assetLinkBtn'><a href={sizeChartLink[0].body} target="_blank">Sizing</a></Button>}</Col>
                                    }
                                    {(!!careInstructionsLink && careInstructionsLink.length !== 0) &&
                                      <Col>{<Button className='assetLinkBtn'><a href={careInstructionsLink[0].body} target="_blank">Care Instructions</a></Button>}</Col>
                                    }
                                    {(!!armorLink && armorLink.length !== 0) &&
                                      <Col>{<Button className='assetLinkBtn'><a href={armorLink[0].body} target="_blank">Impact Protectors</a></Button>}</Col>
                                    }
                                    {(!!replacementPartsLink && replacementPartsLink.length !== 0) &&
                                      <Col>{<Button className='assetLinkBtn'><a href={replacementPartsLink[0].body} target="_blank">Replacement Parts</a></Button>}</Col>
                                    }
                                  </Row>
                                  <br />
                                  </>
                                  : <></>
                                }
                                { accessories.length > 0 &&
                                    <div className="section">
                                        <ProductRelatedProducts
                                            relatedProducts={accessories}
                                            title={"ACCESSORIES"}
                                        />
                                    </div>
                                }
                                { relatedProducts.length > 0 &&
                                    <div className="section">
                                        <ProductRelatedProducts
                                            relatedProducts={relatedProducts}
                                            title={"COMPLETE THE LOOK"}
                                        />
                                    </div>
                                }
                                {/* Videos Section */}
                                {!!allMedia && allMedia.filter((media:IEntityMedia) => media.mediaTypeDescription === "video" && media.tag.toLowerCase() !== 'threesixty' && media.tag.toLowerCase() !== 'bannervideo').map((vid, i) => {
                                    const videoId = getVideoId(vid);
                                    return (
                                        <>
                                        <div className='videoContainer'>
                                            <iframe
                                                allowFullScreen
                                                key={`video-${i}`}
                                                className="video"
                                                frameBorder={0}
                                                src={`https://www.youtube-nocookie.com/embed/${videoId}?wmode=transparent&html5=1&autoplay=0&rel=0`}
                                                style={{width: "100%"}}
                                            />
                                        </div>
                                        </>
                                    )
                                })}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
        </>}
    </Page>
}